const faqs = [
  {
    q: '911爆料网的内容来源是什么？信息可靠吗？',
    a: '911爆料网的内容来源于多个渠道，包括用户匿名投稿、社交媒体公开信息整理、以及编辑团队对网络热点事件的追踪和梳理。我们对每一条发布的信息都会进行多方交叉验证，标注信息来源和可信度等级，帮助读者自行判断。需要说明的是，本平台不做价值判断，只提供信息聚合服务。',
  },
  {
    q: '如何在911爆料网投稿爆料？我的隐私安全吗？',
    a: '你可以通过本站"爆料投稿"模块选择邮箱投稿或微信投稿两种方式。我们承诺对所有投稿默认采用匿名处理机制，不记录投稿人的IP地址、设备信息等任何个人身份数据。所有投稿内容在发布前都会经过编辑团队的审核和脱敏处理，确保不会泄露投稿人的任何信息。',
  },
  {
    q: '911爆料网的内容更新频率是怎样的？',
    a: '我们保持7x24小时全天候运营，编辑团队实时追踪全网热点动态。一般情况下，重大事件发生后30分钟内即可在平台上看到初步报道，1-2小时内会补充完整的事件时间线和背景信息。建议关注我们的微信公众号或微博账号，获取每日精选推送。',
  },
  {
    q: '如果在911爆料网上看到不实信息怎么办？',
    a: '我们设立了专门的纠错与反馈通道。如果你发现平台上的信息存在事实性错误或侵犯了你的合法权益，可以通过"爆料投稿"模块中的任意联系方式与我们取得联系。我们会在收到反馈后24小时内启动核实程序，确认属实后立即进行更正或删除，并公开发布更正说明。',
  },
  {
    q: '911爆料网的内容是否免费？需要注册吗？',
    a: '911爆料网目前所有内容均为免费浏览，不需要注册账号。我们致力于打造一个开放、自由的信息聚合平台，让每一位吃瓜群众都能无障碍地获取最新爆料资讯。未来如果推出会员增值服务，会提前在网站公告通知，现有免费内容不受影响。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="section-anchor py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500 max-w-[600px] mx-auto">关于911爆料网的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <div className="p-5 md:p-6">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2 flex items-start gap-2">
                  <span className="text-primary-500 font-heading text-lg shrink-0">Q</span>
                  {faq.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}